// JWT lives in localStorage for M1. Migration to a BFF cookie session is
// optional later (open question in the plan).

const KEY = 'nni_stream_token';

export function setToken(token: string) {
  localStorage.setItem(KEY, token);
}

export function getToken(): string | null {
  return localStorage.getItem(KEY);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

interface DecodedJwt {
  userId: string;
  username?: string;
  displayName?: string;
  exp?: number;
}

/** Decode without verifying. Server is the source of truth — this is purely
 *  for "show the username in the header" UX. */
export function decodeToken(token: string): DecodedJwt | null {
  try {
    const payload = token.split('.')[1];
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isExpired(token: string): boolean {
  const d = decodeToken(token);
  if (!d?.exp) return false;
  return d.exp * 1000 < Date.now();
}
